import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import type { SfContactResponse } from '../../api/get-sf-contact/getSfContact.types';
import type { SfAccount } from '../../api/types/sfRedirect.types';

/**
 * Navigates to the correct users page once an org is selected
 * and the contact data is available.
 *
 * - Onboarded contact → view/edit panel (`/manage/{id}/users/{userId}`)
 * - New contact → create panel with SF prefill (`/manage/{id}/users/new`)
 */
export function useSfNavigation(
  orgReady: boolean,
  org: SfAccount | undefined,
  contactResponse: SfContactResponse | undefined
): void {
  const navigate = useNavigate();
  const navigationDone = useRef(false);

  useEffect(() => {
    if (!orgReady || !org || !contactResponse || navigationDone.current) return;

    navigationDone.current = true;

    if (contactResponse.isOnboarded && contactResponse.caeConnectContact) {
      navigate(
        `/manage/${org.customerId}/users/${contactResponse.caeConnectContact.id}`,
        { replace: true }
      );
    } else {
      navigate(`/manage/${org.customerId}/users/new`, {
        replace: true,
        state: {
          sfPrefillData: {
            firstName: contactResponse.sfContact.firstName,
            middleName: contactResponse.sfContact.middleName,
            lastName: contactResponse.sfContact.lastName,
            email: contactResponse.sfContact.email,
          },
        },
      });
    }
  }, [orgReady, org, contactResponse, navigate]);
}
